import { Button, dialog } from "nq-component";
import BaseListPresenter from "../../../../../base/BaseListPresenter";

export default class AdditionalTalbePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  init() {
    this.limit = 10;
    const email = this.view.getCurrent();
    this.where = { empID: email };
    this.search = {};
    this.filter = {};
    this.include = ["employee", "timeRecStats", "all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }
  // DialogConfirmation(id) {
  //   dialog.fire({
  //     html: (
  //       <div className="p-2">
  //         <div className="row">
  //           <h4>Delete Confirmation</h4>
  //           <hr />
  //           <p style={{ fontSize: "13px", padding: "1rem" }}>
  //             Are you sure you want to delete?
  //           </p>
  //           <hr />
  //         </div>
  //         <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
  //           <Button
  //             className="btn btn-light fs-sm"
  //             onClick={() => dialog.close()}
  //           >
  //             Cancel
  //           </Button>
  //           <Button
  //             className="btn btn-primary"
  //             onClick={async () => {
  //               this.view.handleDeleteData(id);
  //             }}
  //           >
  //             Confirm
  //           </Button>
  //         </div>
  //       </div>
  //     ),
  //     footer: false,
  //   });
  // }
}
